<template>
    <div class="error-license-admin-no-license">
        <error-license-lock
            :title="$t.__('pages.errors.ErrorLicenseAdminNoLicense.no_licence_available')"
            :subtitles="[
                $t.__('pages.errors.ErrorLicenseAdminNoLicense.to_use_contact_subscription_owner'),
                $t.__('pages.errors.ErrorLicenseAdminNoLicense.can_update_subscription'),
            ]"
        >
            <CompassButton
                :label="labels.buttons.update_subscription"
                size="large"
                @click="goToUrl('/?_f=accountPreferences&action=subscription')"
            />
            <p
                class="error-license-admin-no-license__support typographies-paragraph-medium-semibold"
                v-html="labels.chat"
            />
        </error-license-lock>
    </div>
</template>

<script>
import { goToUrl } from 'vueDir/helpers.js';
import ErrorLicenseLock from 'vcomponents/pages/errors/ErrorLicenseLock.vue';

export default {
    components: {
        ErrorLicenseLock,
    },
    data() {
        return {
            labels: {
                buttons: {
                    update_subscription: this.$l10n.__('Modifier mon abonnement'),
                },
                chat: this.$l10n.__(
                    'Nous vous invitons à prendre contact avec nos conseillers via le %(startTag)s tchat %(endTag)s',
                    {
                        startTag: '<a href="javascript:;" onclick="MySupport.getForm();">',
                        endTag: '</a>',
                    },
                ),
            },
        };
    },
    methods: {
        goToUrl,
    },
};
</script>

<style lang="scss" scoped>
.error-license-admin-no-license {
    &__support {
        color: var(--colors-common-text-standard-default);
        margin: 0;
    }
}
</style>
